const LOCAL_GUARDIAN_API_URL =
   process.env.REACT_APP_STREAM_GUARDIAN_API_BASE_URL || 'https://guardian.nanostream.cloud';
const LOCAL_ANALYTICS_API_URL = process.env.REACT_APP_ANALYTICS_SERVICE_API_BASE_URL || 'https://metrics.nanocosmos.de';
const LOCAL_BINTU_API_URL = process.env.REACT_APP_BINTU_API_BASE_URL || 'https://bintu.nanocosmos.de';
const LOCAL_CTS_API_URL = process.env.REACT_APP_CTS_API_BASE_URL || 'https://token.nanostream.cloud';
const LOCAL_ENV = process.env.REACT_APP_RUM_ENV ? process.env.REACT_APP_RUM_ENV : process.env.NODE_ENV;

export const GUARDIAN_API_URL = window.GUARDIAN_API || LOCAL_GUARDIAN_API_URL;
export const ANALYTICS_API_URL = window.ANALYTICS_API || LOCAL_ANALYTICS_API_URL;
export const BINTU_API_URL = window.BINTU_API || LOCAL_BINTU_API_URL;
export const CTS_API_URL = window.CTS_API || LOCAL_CTS_API_URL;
export const ENV = window.ENV || LOCAL_ENV;
export const VERSION = window.VERSION || '2.28.0';
